import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import CustomizeIcon from '../../images/icons/customize.inline.svg';

import { TransitionMixin, media } from '../helpers';

const CollectionAddToCartContainer = styled.div`
    display: flex;
    ul {
        list-style: none;
        padding: 0;
        margin: 0;

        li {
            text-align: left;
            display: inline-block;
            margin-right: 10px;
            ${media.small`display: inline-block;`}

            &:last-child {
                margin-right: 0px;
            }
            &:first-child {
                span {
                    display: none;
                }
            }

            &.spacer {
                /* display: none;
                ${media.small`display: inline-block;`} */
            }
            a {
                color: #000;
                font-weight: normal;
                padding: 5px 0;
                display: inline-block;
                text-align: left;
                font-size: 0.8rem;
                text-decoration: none;
                ${TransitionMixin('.25s')};

                &:hover {
                    opacity: 0.7;
                }
            }
            &:last-child {
                text-align: right;
                a {
                    color: #000;
                    border: none;
                    text-decoration: underline;
                    span {
                        margin-right: 7px;
                        position: relative;
                        top: 3px;
                    }
                }
            }
        }
    }
`;

const CollectionAddToCart = ({ handle }) => {
    return (
        <CollectionAddToCartContainer>
            <ul>
                <li>
                    <Link to={`/products/${handle}`}>
                        View <span>Product</span>
                    </Link>
                </li>
                <li className="spacer">|</li>
                <li>
                    <Link to={`/products/${handle}?customize`}>
                        <span>
                            <CustomizeIcon />
                        </span>
                        Customize
                    </Link>
                </li>
            </ul>
        </CollectionAddToCartContainer>
    );
};

export default CollectionAddToCart;
